import { render, staticRenderFns } from "./ratio-text.vue?vue&type=template&id=fc3441ac&scoped=true"
import script from "./ratio-text.vue?vue&type=script&lang=js"
export * from "./ratio-text.vue?vue&type=script&lang=js"
import style0 from "./ratio-text.vue?vue&type=style&index=0&id=fc3441ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3441ac",
  null
  
)

export default component.exports